export const VERSION = '1.0.1';
export const UPDATED = 'Thu Feb 20 19:00:01 2025 -0500';
